<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-7">
                <h2>Email Creator</h2>
                <div class="form-group inline-label">
                    <label for="send-email-from">From</label>
                    <input type="text" id="send-email-from" :value="send_email.from.label" readonly></input>
                    <b-form-checkbox v-model="send_email.bcc_me" id="email_to_user" class="float-left">Bcc me</b-form-checkbox>
                </div>
                <div class="form-group inline-label">
                    <label for="send-email-from">To</label>

                    <multiselect
                        v-model="send_email.to"
                        tag-placeholder="Add this as custom email"
                        placeholder="Search user or add an email"
                        open-direction="bottom"
                        label="name"
                        track-by="track"
                        :options="users"
                        :multiple="true"
                        :searchable="true"
                        :loading="isLoading"
                        :internal-search="false"
                        :clear-on-select="false"
                        :close-on-select="false"
                        :options-limit="300"
                        :limit="20"
                        @search-change="getUsers"
                        :max-height="600"
                        :show-no-results="false"
                        :hide-selected="true"
                        :taggable="true"
                        @input="toggleUserToFromMultiselect"
                        @tag="addEmail"
                    >
                        <template slot="tag" slot-scope="{ option, remove }">
                            <span class="custom__tag">
                                <span>{{ option.name }}</span>
                                <span class="custom__remove" @click="remove(option)">
                                    <span aria-hidden="true">&times;</span>
                                </span>
                            </span>
                        </template>
                        <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-if="send_email.to.length" @mousedown.prevent.stop="clearAll(props.search)"></div>
                        </template>
                    </multiselect>
                </div>
                <div class="form-group inline-label">
                    <label for="send-email-from">Subject</label>
                    <b-form-input
                        :id="getId('subject')"
                        type="text"
                        :required="true"
                        v-model="send_email.subject"
                        :state="fieldState('subject')"
                        placeholder="Please add a subject">
                    </b-form-input>
                </div>
                <b-form-invalid-feedback :state="fieldState('subject')">
                    {{invalidField('subject')}} <br /> <br />
                </b-form-invalid-feedback>

                <div class="form-group inline-label">
                    <label for="send-email-template">Template</label>
                    <select type="text" id="send-email-template" v-model="send_email.template" @change="selectTemplate">
                        <option v-for="option in templates" v-bind:value="option">Subject: {{option.subject}}</option>
                    </select>
                    <b-form-checkbox v-model="send_email.save_template" id="save-template" class="float-left">Save template</b-form-checkbox>
                </div>

                <div class="form-group">
                    <el-upload
                        class="upload-attachment"
                        action="#"
                        :auto-upload="false"
                        :on-remove="handleRemoveFile"
                        :on-change="handleAddFile"
                        multiple
                        :limit="5"
                        :on-exceed="handleExceed"
                        :file-list="send_email.attachments">
                        <el-button size="small" type="primary">Click to upload</el-button>
                        <div slot="tip" class="el-upload__tip">Maximum 5 files, file size should be less than 50MB</div>
                    </el-upload>
                </div>

                <editor :api-key="TINYMCE_API_KEY" :init="editor_settings" v-model="send_email.content"/>

                <div class="buttons mt-4">
                    <div class="container-buttons">
                        <a class="btn btn-primary" @click="sendEmail" :disabled="isLoading">Send</a>
                        <a class="btn btn-primary ml-3" @click="cancel">Cancel</a>
                    </div>
                </div>
                <div class="mt-4">
                    <messages :messages="messages"/>
                </div>
            </div>
            <div class="col-5">
                <h2>Search Users</h2>
                <div class="form-group form-inline">
                    <b-form-radio-group  v-model="search_criteria.filter_by_status" @change="getUsers(search_criteria.query)">
                        <b-form-radio value="1" id="search-criteria-filter-by-active" class="float-left">Active</b-form-radio>
                        <b-form-radio value="2" id="search-criteria-filter-by-preview" class="float-left">Preview</b-form-radio>
                        <b-form-radio value="3" id="search-criteria-filter-by-stock" class="float-left">Stock</b-form-radio>
                        <b-form-radio value="all" id="search-criteria-filter-by-all" class="float-left">All</b-form-radio>
                    </b-form-radio-group>
                    <b-form-checkbox v-model="send_email.include_reps" id="search-criteria-include-reps" class="float-left" @change="getUsers(search_criteria.query)">Include Reps</b-form-checkbox>
                </div>
                <div class="row">
                    <div class="col-12">
                        <input type="text" id="search-criteria-company" class="w-100" v-model="search_criteria.query" placeholder="Search users" @input="searchUsers"></input>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="user-list-container" v-if="users.length">
                            <div class="select-all">
                                <b-form-checkbox v-model="search_criteria.select_all" id="search-criteria-select-all" class="" @change="selectAll">All / None</b-form-checkbox>
                            </div>
                            <b-form-checkbox-group
                                v-model="search_criteria.selected"
                                :options="users"
                                class="mb-3"
                                value-field="track"
                                text-field="name"
                                @change="toggleUserTo"
                            >
                            </b-form-checkbox-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import Multiselect from "vue-multiselect"
import LaravelRouter from '../../thirdparty/Ziggy/route'
import BootstrapValidation from '../../mixins/bootstrap-validation';
import axios from "axios";
import {getExceptionErrorMessage, getHttpValidationErrors} from "../../util/common";

const user = window.loggedInUser;
const defaultTemplate = () => {
    let content = `
        <br><br><br>
        <p style="padding-top: 15px;border-top: 9px solid #006698;font-size: 13px; color: #006698; a, a:visited{color: #006698;}">
        <strong>${user.first_name} ${user.last_name}</strong><br>
        Phone   ${user.profile.phone}<br>
        Mobile   ${user.profile.mobile}<br>
        Email    ${user.email}<br>
        ${user.company.name} <a href="https://car-go.co.nz">car-go.co.nz</a><br>
        </p>
    `;
    if (user.privileges.enable_signature && user.signature) {
        content = '';
    }
    return {
        subject: 'New Email',
        content: content,
        id: null
    }
};

export default {
    name: "send-email",
    components: {
        Editor,
        Multiselect
    },
    mixins: [BootstrapValidation],
    data() {
        return {
            isLoading: false,
            userSearchCancelToken: null,
            messages: [],
            errors: [],
            editor_settings: {
                height: 300,
                menubar: false,
                placeholder: "Start typing your email...",
                plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount'
                ],
                toolbar_location: 'bottom',
                toolbar: ['undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help']
            },
            send_email: this.resetSendEmailObject(),
            templates: [defaultTemplate()],
            users: [],

            search_criteria: {
                query: '',
                filter_by_status: 'all',
                select_all: false,
                selected: [],
            },
        }
    },
    mounted() {
        this.getDefaultTemplates();
    },
    computed: {
        //
    },
    methods: {
        resetSendEmailObject () {
            return {
                from: this.currentUserFrom(),
                bcc_me: false,
                include_reps: false,
                save_template: false,
                to: [],
                attachments: [],
                subject: null,
                content: defaultTemplate().content,
                template: defaultTemplate()
            }
        },
        currentUserFrom () {
            return {
                label: `${user.first_name} ${user.last_name} <${user.email}>`,
                email: user.email
            }
        },
        getId(name){
            return name;
        },
        addEmail (newEmail) {
            const custom_email = {
                name: newEmail,
                user_id: null,
                email: newEmail,
                track: this.$createHash(newEmail),
                is_user: false
            }
            this.send_email.to.push(custom_email)
        },
        selectAll (selected) {
            this.search_criteria.selected = [];
            if (selected) {
                this.send_email.to = this.users
                this.send_email.to.forEach((user) => {
                    this.search_criteria.selected.push(user.track);
                })
            } else {
                this.send_email.to = []
            }
        },
        getUserByTrack (track) {
            let user_tracked = false;
            this.users.forEach((user) => {
                if (user.track === track) {
                    user_tracked = user;
                }
            })
            return user_tracked;
        },
        toggleUserTo (selected) {
            console.log(event,'TEST')
            this.send_email.to = []
            selected.forEach((track) => {
                let user = this.getUserByTrack(track);
                if (user) {
                    this.send_email.to.push(user)
                }
            })
        },
        toggleUserToFromMultiselect (selected) {
            console.log(selected,'TEST')
            this.search_criteria.selected = []
            selected.forEach((select) => {
                this.search_criteria.selected.push(select.track)
            })
        },
        searchUsers (event) {
            this.getUsers(event.target.value)
        },
        getUsers (query) {
            this.$nextTick(() => {

                if (this.userSearchCancelToken) {
                    this.userSearchCancelToken.cancel('Request cancelled for new request')
                }
                this.userSearchCancelToken = this.axios.CancelToken.source();
                this.isLoading = true
                this.users = [];
                this.$store.dispatch('users/getUsers',{
                    args: {
                        searchUser: query,
                        filter_by_statuses: this.search_criteria.filter_by_status === 'all' ? [1,2,3] : [parseInt(this.search_criteria.filter_by_status)],
                        filter_by_sales_rep: false,
                        filter_by_roles: this.send_email.include_reps ? [1,2,3,4] : [2],
                        per_page: 1000,
                        sort_asc: 1
                    },
                    cancelToken: this.userSearchCancelToken
                }).then(response => {
                    response.data.forEach(user => {
                        let company = user.company ? `(${user.company.name})` : ''
                        this.users.push({
                            name: `${user.first_name} ${user.last_name} ${company} [${user.email}]`,
                            user_id: user.id,
                            track: this.$createHash(user.id),
                            email: null,
                            is_user: true
                        })
                    })
                    this.isLoading = false
                }).catch(e => console.warn('send-email/getUsers catch', e));
            })
        },
        clearAll () {
            this.send_email.to = []
        },
        selectTemplate (event) {
            this.$bvModal
                .msgBoxConfirm('Are you sure? It will replace your current data in the editor including the selected users')
                .then(value => {
                    if (value) {
                        const value = this.send_email.template
                        this.send_email.content = value.content
                        this.send_email.subject = value.subject === 'New Email' ? '' : value.subject
                        this.send_email.to = []
                        if (value.to) {
                            this.send_email.to = JSON.parse(value.to);
                        }
                    }
                })
        },
        async sendEmail () {
            this.messages = []
            try{
                this.isLoading = true
                let route = LaravelRouter('email-creator.sendEmail', false);
                const { data } = await axios.post(route, this.send_email)
                this.isLoading = false
                if (data.templates.length) {
                    this.templates = [defaultTemplate()]
                    data.templates.forEach( template => {
                        this.templates.push(template)
                    })
                    this.send_email = this.resetSendEmailObject()
                }
                this.messages = [{message: 'Email has been sent', type: 'success'}];
                this.$message.success('Email has been sent...')
            } catch (error) {
                this.isLoading = false
                let message = getExceptionErrorMessage(error);
                this.messages.push({type: 'danger', message});
                let errors = getHttpValidationErrors(error);
                if (errors) {
                    this.errors = errors;
                }
            }

        },
        cancel () {
            this.$bvModal
                .msgBoxConfirm('Do you want to discard this email?')
                .then(value => {
                    if (value) {
                        window.location.reload();
                    }
                })
        },
        async getDefaultTemplates () {
            try{
                let route = LaravelRouter('email-creator.templates', false);
                const { data } = await axios.get(route)
                if (data.length) {
                    data.forEach( template => {
                        this.templates.push(template)
                    })
                }
            } catch (e) {
                console.error('There was a problem sending the email', e)
                this.$message.error('There was a problem sending the email.')
            }
        },
        handleExceed(files, fileList) {
            this.$message.warning(`The limit is 5, you selected ${files.length} files this time, add up to ${files.length + fileList.length} totally, The rest is automatically ignored`);
        },
        handleRemoveFile(file, fileList) {
            if (file && file.uid && file.url) {
                this.removeAttachment(file.uid, file.url)
            } else {
                this.$message.error('There was a problem removing the file.')
            }
        },
        async removeAttachment(uid, attachmentUrl) {
            if (uid && attachmentUrl) {
                const errorMsg = 'There was a problem removing attachment.';
                try {
                    let route = LaravelRouter('email-creator.removeAttachment', false);
                    let data = new FormData();
                    data.append('url', attachmentUrl);
                    let res = await this.axios.post(route, data);
                    if (res.status === 200) {
                        this.send_email.attachments.forEach((attachment, index) => {
                            if (attachment.uid === uid) {
                                this.send_email.attachments.splice(index, 1)
                                return;
                            }
                        })
                    } else {
                        this.$message.error(errorMsg)
                    }
                } catch (e) {
                    console.error('There was a problem uploading attachment', e)
                    this.$message.error(errorMsg)
                }
            } else {
                console.error('Error, missing uid or url.')
            }
        },
        handleAddFile(file, fileList) {
            if (file && file.uid && file.raw) {
                this.uploadAttachment(file.uid, file.raw)
            } else {
                this.$message.error('There was a problem uploading the file.')
            }
        },
        async uploadAttachment(uid, attachment) {
            if (uid && attachment) {
                const errorMsg = 'There was a problem uploading attachment.';
                try {
                    let route = LaravelRouter('email-creator.uploadAttachment', false);
                    let data = new FormData();
                    data.append('uid', uid);
                    data.append('attachment', attachment);
                    let res = await this.axios.post(route, data);
                    if (res.status === 200 && res.data && res.data.url &&  res.data.uid && res.data.name) {
                        this.send_email.attachments.push({
                            uid: res.data.uid,
                            url: res.data.url,
                            name: res.data.name,
                            status: 'success'
                        })
                    } else {
                        this.$message.error(errorMsg)
                    }
                } catch (e) {
                    console.error('There was a problem uploading attachment', e)
                    this.$message.error(errorMsg)
                }
            } else {
                console.error('Error, missing uid or attachment.')
            }
        }
    },
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// resources/js/components/EmailCreator/send-email.vue